// extracted by mini-css-extract-plugin
module.exports = {"sourceContainer":"SingleSource_sourceContainer__7dd36","source":"SingleSource_source__3iu09","icon":"SingleSource_icon__1ed4k"};